<template>
  <div>
    <!-- Botão para gerar o PDF -->
    <button @click="gerarPDF">Gerar PDF</button>

    <!-- Conteúdo da tabela -->
    <div id="pdfContent">
      <!-- Cabeçalho -->
      <div>
        <h2>Nome da Empresa</h2>
        <h3>{{ operador.nome }}</h3>
      </div>

      <!-- Tabela com os dados -->
      <table style="border-collapse: collapse;">
        <!-- Cabeçalho da tabela -->
        <thead>
          <tr>
            <th>Data Serviço</th>
            <th v-for="i in 8" :key="i">Marcação {{ i }}</th>
          </tr>
        </thead>

        <!-- Corpo da tabela -->
        <tbody>
          <tr v-for="item in this.fichaponto" :key="item.id">
            <td>{{ formatarData(item.dt_servico) }}</td>
            <td v-for="i in 8" :key="i">
              <div style="width: 3cm; height: 3cm; border: 1px solid black; text-align: center; font-size: 9px;">
                <img :src="getFoto(item['v' + i])" alt="Foto" style="max-width: 100%; max-height: 50%;">
                <div>{{ formatarData(item['v' + i]) }}</div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>

      <!-- Rodapé -->
      <div>
        <p>Endereço XPTO</p>
      </div>
    </div>
  </div>
</template>

<script>
import html2pdf from 'html2pdf.js';

export default {
  data() {
    return {
      
    };
  },
  methods: {
    gerarPDF() {
      const opt = {
        margin: 10,
        filename: 'ficha_ponto.pdf',
        image: { type: 'jpeg', quality: 0.98 },
        html2canvas: { scale: 2 },
        jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
      };

      const element = document.getElementById('pdfContent');

      html2pdf().from(element).set(opt).save();
    },
    formatarData(data) {
      return data ? new Date(data).toLocaleDateString('pt-BR') : '';
    },
    getFoto(valor) {
      if (!valor) return '';
      const partes = valor.split('##');
      return partes[1];
    },
  },
};
</script>

<style>
/* Adicione estilos CSS aqui, se necessário */
</style>
